// Slot-based copy of StudentPanel's layout (src/component/student-components/StudentPanel.jsx,
// the non-Vizmental branch): an optional strip on top (PeerInstruction's stepper), then
// three columns - task/tests on the left, the code column in the middle and the chat on
// the right - separated by the same drag-bar elements.
//
// Same DOM and classes as the real panel, so the real stylesheets apply. It does NOT read
// any context and the splitters are static (the real ones come from useResizable, which
// listens on window); the column widths are the real useResizable initial values.
//
// Used by StudentPanelPreview (read-only facsimile leaves in the slots) and by the
// instructor's student-layout "Task and Unit Test" tab (real, editable components in the
// slots).

import React from 'react'
import { cn } from '../../../pages/SampleSplitter'
import '../../../css/codeIssuePanel.scss'
import '../../../css/dragBar.scss'
import '../../../css/studentview-panel.scss'
import { PeerInstructionFacsimile } from './studentPanelFacsimile'

// StudentPanel: useResizable({ initial: 500 }) for both the file and the plugin column.
export const STUDENT_PANEL_LEFT_WIDTH = 500
export const STUDENT_PANEL_CHAT_WIDTH = 500

// SampleSplitter's markup without its focus state / drag wiring.
function StaticSplitter() {
  return <div className={cn('sample-drag-bar')} aria-hidden="true" />
}

const DEFAULT_TOP = <PeerInstructionFacsimile />

export default function StudentPanelShell({
  left = null,
  code = null,
  chat = null,
  leftWidth = STUDENT_PANEL_LEFT_WIDTH,
  chatWidth = STUDENT_PANEL_CHAT_WIDTH,
  height = '100%',
  top = DEFAULT_TOP,
  className = '',
  // Optional extra attributes for the chat column (the live preview's region marker).
  chatProps = null,
}) {
  return (
    <div
      className={cn(
        'div-height flex flex-column h-screen bg-dark font-mono color-white max-screen-width',
        'svp-shell',
        className
      )}
      style={{ height }}>
      <div className="flex-row" />
      {top}
      <div className={'flex grow svp-cols'}>
        <div
          className={'shrink-0 contents svp-col-left'}
          style={{ width: leftWidth }}>
          {left}
        </div>
        <StaticSplitter />
        <div className={'flex grow'}>
          <div className={'grow contents-code svp-col-code'} style={{ width: 0 }}>
            {code}
          </div>
          {chat != null && (
            <>
              <StaticSplitter />
              <div
                className={'shrink-0 bg-darker contents-chat svp-col-chat'}
                style={{ width: chatWidth }}
                {...chatProps}>
                {chat}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  )
}
